import { FocusEvent } from 'react'

import { tableClass } from 'core-components/library/selects'

import { IGNORE_BLUR_CLASS } from '../constants'

export const onBlurHelper = (
  event: FocusEvent<HTMLDivElement>,
  value: string,
  inputted: string,
  setInputted: (v: string) => void,
  onBlur?: () => void
) => {
  const relatedTarget = event?.relatedTarget
  if (!relatedTarget?.closest(`.${tableClass}`)) {
    const emptyString = ''
    if (inputted === emptyString) {
      setInputted(emptyString)
    } else if (value !== inputted) {
      setInputted(value)
    }
    if (onBlur) {
      onBlur()
    }
  }
}

export const needHandleBlur = (event: FocusEvent<HTMLDivElement>) => {
  return !event?.relatedTarget?.closest(`.${IGNORE_BLUR_CLASS}`)
}
